import React from "react";
import styles from "./index.module.css";

function Loader() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
}

export default Loader;
